import { h, Component, createRef } from 'preact';
import styled from 'styled-components';
import {
  TAB_KEYCODE,
  DEFAULT_CLOSE_BUTTON_TEXT,
  PROVISIONS,
} from '../../common/constants';
import COLORS from '../../common/colors';

const StyledDeferredButton = styled.button`
  ${({ isInviteReflow, isDirectionRtl }) => (isInviteReflow ? `
    right: ${isDirectionRtl ? 'unset' : '10px'};
    left: ${isDirectionRtl ? '10px' : 'unset'};
    width: 24px;
    border-radius: 1px;
    background-repeat: no-repeat;
    top: 8px;
    min-width: fit-content;
    height: fit-content;
    line-height: 1;
    align-self: flex-end;
  ` : `
  float: ${isDirectionRtl ? 'left' : 'right'};
  right: ${isDirectionRtl ? '-11px' : '11px'};
  top: 5px;
  `)}
  position: relative;
  color: black;
  font-size: 24px;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  visibility: ${({ visibility }) => visibility || 'visible'};
  &:active,
  &:focus {
    outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
  }
`;

function preventDefault(ev) {
  ev.preventDefault();
  ev.stopPropagation();
}

export default class DeferButton extends Component {
  constructor(props) {
    super(props);
    this.deferBtnRef = createRef();
  }
  componentDidMount() {
    if (!this.props.provisions[PROVISIONS.NEW_MODAL_DIALOGS]) {
      this.base.addEventListener('keydown', ev => {
        if ((ev.which || ev.keyCode === TAB_KEYCODE) && ev.shiftKey) {
          preventDefault(ev);
          document.getElementById('nebula-question-icon').focus();
        }
      });
    }
  }
  render() {
    return (
      <StyledDeferredButton
        isDirectionRtl={this.props.isDirectionRtl}
        isInviteReflow={this.props.isInviteReflow}
        visibility={this.props.visibility}
        ref={this.deferBtnRef}
        isWCAG={this.props.isWCAG}
        tabIndex="0"
        onClick={this.props.onClick}
        id="kplDeferButton"
        className="xDix"
        aria-label={this.props.closeModalButton || DEFAULT_CLOSE_BUTTON_TEXT}
        role="button"
      >
        &times;
      </StyledDeferredButton>
    );
  }
}

DeferButton.defaultProps = {
  provisions: {},
};
